import { formatOptionsLines } from '../../utils/caisseProduct';

/**
 * Détail des options en panier — style ticket / caisse pro.
 */
export default function CaissePanierOptions({ options, className = '' }) {
  const lines = formatOptionsLines(options);
  if (lines.length === 0) return null;

  return (
    <ul className={`mt-1.5 list-none m-0 p-0 space-y-0.5 ${className}`}>
      {lines.map((line) => (
        <li
          key={`${line.group}-${line.choices}`}
          className="flex gap-2 items-baseline text-[13px] leading-snug pl-0.5"
        >
          <span className="text-slate-400 shrink-0 w-2 text-center" aria-hidden>
            –
          </span>
          <span className="min-w-0 text-left">
            <span className="text-slate-500 font-medium">{line.group}</span>
            <span className="text-slate-400 mx-1">:</span>
            <span className="text-slate-900 font-semibold">{line.choices}</span>
          </span>
        </li>
      ))}
    </ul>
  );
}
